export default {
  SET_IS_USER_GUIDE_ACTIVE(state, data) {
    state.isUserGuideActive = data;
  },
  SET_STEP(state, data) {
    state.step = data;
  },
};
